<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Управление_Источниками_импорта") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">
            {{ $t("message.Источники_импорта") }}
          </li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper" v-if="!hasReadPermissions">
      {{ $t("message.Нет_прав_доступа_на_чтение") }}
    </div>
    <div id="main-wrapper" v-if="hasReadPermissions">
      <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">
        {{ $t("message.Добавить_EPG") }}
      </b-button>
      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
      >
        <template slot="name" slot-scope="data">
          {{ data.item.name }}
        </template>
        <template slot="actions" slot-scope="row">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <router-link
            class="btn btn-secondary btn-sm mr-1"
            :to="{ path: '/source-channels/' + row.item.id }"
          >
            <i class="fas fa-list"></i>
          </router-link>
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
        </template>
        <template slot="enabled" slot-scope="data">
          <i
            class="fa fa-check"
            aria-hidden="true"
            v-if="data.item.enabled == true"
          ></i>
          <i
            class="fa fa-ban"
            aria-hidden="true"
            v-if="data.item.enabled == false"
          ></i>
        </template>
        <template slot="packages" slot-scope="data">
          <b-badge
            class="mr-1"
            v-for="pack in data.item.packages"
            :key="pack.id"
            >{{ pack.name }}</b-badge
          >
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>

      <b-modal
        id="modalInfo"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Источники_импорта_-_Редактирование')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-esc
        no-close-on-backdrop
      >
        <EPG_SourceForm :model="EPG_model"></EPG_SourceForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import EPG_SourceForm from "./EPG_SourcesForm";

export default {
  name: "EPG_Sources",
  components: {
    EPG_SourceForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "name", sortable: true },
        { key: "handler", sortable: true },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      EPG_model: {},
      channels: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 0
    };
  },
  computed: {
    hasReadPermissions: function() {
      return !!this.$storage
        .get("current_user")
        .permissions.filter(value => value == "epgsources:fully_manage").length;
    }
  },
  methods: {
    created() {},
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("epg_sources", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.unauthorized_error);
    },
    editRow(item, index, button) {
      this.EPG_model = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.EPG_model.id > 0) {
        this.$noname
          .patch("epg_sources", this.EPG_model.id, this.EPG_model)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("epg_sources", this.EPG_model)
          .then(Reponse => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");

            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      }
    },
    addRow() {
      this.EPG_model = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_источник?"))
        .then(response => {
          this.$noname
            .delete("epg_sources", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "device-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });

              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    },
    loadChannels(sourceId) {
      this.channels = [];

      let promise = this.$noname.getChild("epg_sources", sourceId, "channels");

      promise
        .then(data => {
          const items = data.data.items;

          this.channels = items;

          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(error => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle busy state in case of error
          Vue.notify({
            group: "notify",
            text:
              this.$i18n.t("message.Ошибка_получения_данных") + ":<br>" + error,
            type: "error"
          });
          return [];
        });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/modules/EPG_Sources.vue